const CURRENCY_SYMBOL_PATTERN = /[€$£]|(?:^|\s)(?:EUR|USD|GBP)(?:\s|$)/i;

export const parseRevealNumber = (raw: string): number | undefined => {
	const stripped = raw.replace(CURRENCY_SYMBOL_PATTERN, '').replace(/\s/g, '').trim();

	if (!/^-?[\d.,]+$/.test(stripped) || !/\d/.test(stripped)) {
		return undefined;
	}

	const lastDot = stripped.lastIndexOf('.');
	const lastComma = stripped.lastIndexOf(',');

	let normalized: string;
	if (lastDot !== -1 && lastComma !== -1) {
		normalized =
			lastDot > lastComma
				? stripped.replace(/,/g, '')
				: stripped.replace(/\./g, '').replace(',', '.');
	} else if (lastDot !== -1 || lastComma !== -1) {
		const separator = lastDot !== -1 ? '.' : ',';
		const parts = stripped.split(separator);
		const isThousands =
			parts.length > 1 &&
			parts.slice(1).every((part) => part.length === 3) &&
			parts[0].replace('-', '').length <= 3;
		normalized = isThousands
			? parts.join('')
			: parts.length === 2
				? `${parts[0]}.${parts[1]}`
				: stripped;
	} else {
		normalized = stripped;
	}

	const parsed = Number(normalized);
	return Number.isFinite(parsed) ? parsed : undefined;
};
